import React from "react";
import EmptyState from "./EmptyState";
import TooltipUI from "./Tooltip";
import InfoIcon from "./InfoIcon";

const TopFrequentWordsCard = ({ words = [] }) => {
  // Check if we have actual data
  if (!words || words.length === 0) {
    return (
      <div className="bg-white-f p-5 rounded-lg border border-grey-20 shadow-subtle h-full">
        <div className="flex items-center gap-1 mb-4">
          <h3 className="text-sm font-normal text-black-0">Top frequent words</h3>
          <TooltipUI
            content="Most common words in the selected period, annotated by sentiment where available."
            placement="bottom"
            align="start"
          >
            <span className="inline-flex cursor-help">
              <InfoIcon />
            </span>
          </TooltipUI>
        </div>
        <EmptyState
          variant="no-data"
          title="No sentiment data available"
          description="There's no sentiment analysis data for the selected period. Try selecting a different date range."
          actionButton={null}
        />
      </div>
    );
  }

  // Function to determine badge color based on sentiment
  const getBadgeColor = (sentiment) => {
    switch (sentiment) {
      case "positive":
        return "bg-[#DAFBEB] text-black-0";
      case "negative":
        return "bg-[#FBDADA] text-black-0";
      case "neutral":
      default:
        return "bg-grey-20 text-black-0";
    }
  };

  // Get the most frequent word (we know words.length > 0 here)
  const mostFrequentWord = words[0].text;

  return (
    <div className="bg-white-f p-5 rounded-lg border border-grey-20 shadow-subtle h-full">
      <div className="mb-4 flex flex-col gap-1">
        <div className="flex items-center gap-1">
          <h3 className="text-sm font-normal text-black-0">Top frequent words</h3>
          <TooltipUI
            content="Most common words in the selected period, annotated by sentiment where available."
            placement="bottom"
            align="start"
          >
            <span className="inline-flex cursor-help">
              <InfoIcon />
            </span>
          </TooltipUI>
        </div>
        <div className="flex items-baseline gap-2">
          <p className="font-medium text-[18px] text-black-0">
            {mostFrequentWord}
          </p>
          <span className="text-[12px] text-grey-60">is most frequent word</span>
        </div>
      </div>
      
      <div className="h-[200px] overflow-y-auto">
        <div className="flex flex-wrap gap-2">
          {words.map((word, index) => (
            <span
              key={index}
              className={`px-3 py-1 rounded-full text-sm ${getBadgeColor(word.sentiment)}`}
            >
              {word.text} {word.count > 1 && <span className="text-grey-60">({word.count})</span>}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopFrequentWordsCard; 